import { createActionFactory } from '../../../common/redux';

const { createAction, createApiFailureAction } = createActionFactory('Email Integrations => ');

// ######################################################################################## //
// EMAIL INTEGRATION ACTIONS
// ######################################################################################## //

//used to fire the request for getting the initial Notification List
const fetchNotificationList = createAction('fetch notification list', (experienceId, accountId) => ({
  experienceId,
  accountId,
}));
//after the request was a success, we set the notification list to the one retrieved by the API
const fetchNotificationListSuccess = createAction('setting notification list', (emailTemplateList) => ({
  emailTemplateList,
}));
const fetchNotificationListFailure = createApiFailureAction('failed to retrieve notification list');

//used to fire up the request to remove a notification
const promptRemoveNotification = createAction(
  'prompt to verify removal of specific notification request',
  (emailTemplateId) => ({
    emailTemplateId,
  })
);
const cancelRemoveNotification = createAction('close delete notification warning message');
//used to fire up the request to remove a notification
const removeNotification = createAction('remove specific notification request', (emailTemplateId) => ({
  emailTemplateId,
}));
//remove the data from the state tree
const removeNotificationSuccess = createAction('remove specific notification request success', (emailTemplateId) => ({
  emailTemplateId,
}));
//used when there is non 20X response from server
const removeNotificationFail = createApiFailureAction('remove specific notification request fail');

const enableNotification = createAction('requesting to enable notification', (emailTemplateId) => ({
  emailTemplateId,
}));
const disableNotification = createAction('requesting to disable notification', (emailTemplateId) => ({
  emailTemplateId,
}));

const enableNotificationFail = createApiFailureAction('failed to enable notification');
const disableNotificationFail = createApiFailureAction('failed to disable notification');

//used when updating a notification in the emailTemplateList
const updateNotificationStatusFromList = createAction(
  'updates a single email template from the local list',
  (emailTemplate) => ({ emailTemplate })
);

export default {
  promptRemoveNotification,
  cancelRemoveNotification,
  removeNotification,
  removeNotificationSuccess,
  removeNotificationFail,
  fetchNotificationList,
  fetchNotificationListSuccess,
  fetchNotificationListFailure,
  updateNotificationStatusFromList,
  disableNotification,
  enableNotification,
  disableNotificationFail,
  enableNotificationFail,
};
